import { createFileRoute } from "@tanstack/react-router";

import { AgentChatSession } from "@/components/chat/session";
import { ProtectedLayout } from "@/components/layout/protected";
import { ResponsiveMain } from "@/components/layout/main";
import { ResponsiveSidebar } from "@/components/layout/sidebar";

import { ChatApiFactory } from "@/apis/chat";
import { SocketProvider, useSetupGlobalEvents } from "@/context/socket";
import { ChatSession as IChatSession } from "@/schema/chat";

export const Route = createFileRoute("/chat/r/$session")({
  loader: async ({ params }) => ChatApiFactory.Apis.FetchChatSessionRestricted(params.session),
  component: RouteComponent,
  staleTime: 0,
  gcTime: 0,
});

function RouteComponent() {
  const data = Route.useLoaderData();
  useSetupGlobalEvents();

  return (
    <ProtectedLayout mode="dashboard">
      <SocketProvider>
        <ResponsiveSidebar />
        <ResponsiveMain>
          <ChatSession key={data.id} data={data} />
        </ResponsiveMain>
      </SocketProvider>
    </ProtectedLayout>
  );
}

interface ChatSessionProps {
  data: IChatSession;
}

function ChatSession({ data }: ChatSessionProps) {
  return <AgentChatSession key={data.id} data={data} visibility="private" />;
}
